import { useTheme } from '@emotion/react';
import { ThemeProvider } from '@mui/system';
import { createTheme } from '@mui/material/styles';

function CalendarTheme({ children }) {
    const theme = useTheme();
    const borderColor = theme.palette.grey[300];
    const backgroundColor2 = theme.palette.grey[200];
    const backgroundColor = theme.palette.background.paper;
    const textColor = theme.palette.grey[900];

    const newTheme = (theme) => createTheme({
        ...theme,
        components: {
            MuiDateCalendar: {
                styleOverrides: {
                    root: {
                        width: "100%",
                        height: "auto",
                        maxHeight: "100vh",
                        '& .MuiDayCalendar-header': {
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        },
                    },
                    viewTransitionContainer: {
                        margin: "0 auto",
                        maxWidth: "100%",
                        padding: "0 1rem",
                        width: "100%",
                    },
                },
            },
            MuiPickersSlideTransition: {
                styleOverrides: {
                    root: {
                        height: "auto",
                        maxHeight: "100vh",
                        width: "100%",
                    }
                }
            },
            MuiDayCalendar: {
                styleOverrides: {
                    header: {
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: "0.5rem 0",
                    },
                    weekContainer: {
                        width: "100%",
                        justifyContent: "space-between",
                    },
                    // Add specific styling for weekday labels
                    weekDayLabel: {
                        width: "clamp(2rem, 4vw, 3rem)",
                        padding: "clamp(0.1rem, 0.5vw, 0.25rem)",
                        textAlign: "center",
                        margin: "0",
                    }
                }
            },
            MuiPickersDay: {
                styleOverrides: {
                    root: {
                        fontSize: "clamp(0.75rem, 1.5vw, 1.2rem)",
                        margin: "0",
                        width: "clamp(2rem, 4vw, 3rem)",
                        height: "clamp(2rem, 4vw, 3rem)",
                        borderRadius: "50%",
                    }
                }
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        fontSize: "clamp(0.75rem, 1.5vw, 1.2rem)",
                        padding: "clamp(0.25rem)"
                    },
                    // Add specific styling for caption which affects weekday labels
                    caption: {
                        '&.MuiDayCalendar-weekDayLabel': {
                            width: "clamp(2rem, 4vw, 3rem)",
                            textAlign: "center",
                            fontSize: "clamp(0.7rem, 1.2vw, 1rem)",
                        }
                    }
                }
            },
            // Add styles for month selection header
            MuiPickersCalendarHeader: {
                styleOverrides: {
                    root: {
                        width: "100%",
                        height: "auto",
                        maxHeight: "100vh",
                        padding: "0.5rem 0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    },
                    label: {
                        fontSize: "clamp(1rem, 2vw, 1.5rem)",
                    }
                }
            },
        }
    });

    return (
        <ThemeProvider theme={newTheme}>
            {children}
        </ThemeProvider>
    );
}

export default CalendarTheme;